import {Component, EventEmitter, Output, computed, input, Input} from '@angular/core';
import { regularWithdrawalFrequencyMap } from 'src/models/common.model';
import { IRegularWithdrawal } from 'src/models/products.model';
import { IPortfolioAvatarInput } from '../liberro-avatar-photo-tagged/liberro-avatar-photo-tagged.component';

@Component({
  selector: 'liberro-regular-withdrawal-investment-tile',
  standalone: false,
  templateUrl: './liberro-regular-withdrawal-investment-tile.component.html',
  styleUrl: './liberro-regular-withdrawal-investment-tile.component.less'
})
export class LiberroRegularWithdrawalInvestmentTileComponent {
   @Input({required: true}) public regularWithdrawalInvestment!: IRegularWithdrawal;
   @Output() public regularWithdrawalInvestmentSelected = new EventEmitter<number>();
   public regularWithdrawalFrequencyMap = regularWithdrawalFrequencyMap;

  public avatarInput = computed<IPortfolioAvatarInput>(() => ({
    portfolioType: this.regularWithdrawalInvestment.portfolioType,
    image: this.regularWithdrawalInvestment.image,
  }));

  public selectRegularWithdrawalInvestment(regularWithdrawalInvestmentId: number): void {
    this.regularWithdrawalInvestmentSelected.emit(regularWithdrawalInvestmentId);
  }
}
